module.exports = __webpack_public_path__ + "2f7d887fda7e8ccbcae24bf6ca6af033.svg";